module.exports = __webpack_public_path__ + "img/0xcd48b160c1bbc9d74997b803b9a7ad50a4bef020.fd79aae2.png";